export default "__VITE_ASSET__DAe56a$x__"